import React from 'react';
import { ArrowRight, Camera, Leaf } from 'lucide-react';

const Hero = ({ language }) => {
  const texts = {
    en: {
      title: 'Welcome to Souschaif',
      subtitle: 'Your AI-Powered Kitchen Companion',
      cta: 'Join Now',
      subtitle2: 'Create delicious, sustainable meals with what you already have at home.'
    },
    sl: {
      title: 'Dobrodošli v Souschaif',
      subtitle: 'Vaš AI kuhinjski spremljevalec',
      cta: 'Pridružite se',
      subtitle2: 'Ustvarjajte okusne in trajnostne obroke iz sestavin, ki jih že imate doma.'
    }
  };

  const t = texts[language];

  return (
    <section id="section-1" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-emerald-50 via-lime-50 to-green-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {t.title}
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {t.subtitle}
              </p>
              <p className="text-lg text-gray-500">
                {t.subtitle2}
              </p>
            </div>

            {/* CTA Button */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/s" className="inline-flex items-center justify-center px-8 py-4 bg-emerald-600 text-white rounded-xl font-semibold text-lg hover:bg-emerald-700 transition-colors duration-200 shadow-lg">
                <Camera className="w-5 h-5 mr-2" />
                <span>{t.cta}</span>
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </div>

            <div className="flex items-center space-x-2 text-emerald-700">
              <Leaf className="w-5 h-5" />
              <span className="text-sm font-medium">
                {language === 'en' ? 'Reduce food waste, save money, and cook smarter' : 'Zmanjšajte odpadno hrano, prihranite denar in kuhajte pametneje'}
              </span>
            </div>
          </div>

          {/* Right side - Hero Image */}
          <div className="relative">
            {/* Decorative background elements */}
            <div className="absolute -z-10 top-8 right-8 w-72 h-72 bg-emerald-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
            <div className="absolute -z-10 bottom-8 left-8 w-72 h-72 bg-lime-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
            
            <div className="relative rounded-2xl shadow-2xl overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-tr from-emerald-600/10 to-lime-600/10 rounded-2xl z-10"></div>
              <img
                src="https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=1200&q=80"
                alt={language === 'en' ? 'Fresh ingredients and a smartphone in a modern kitchen' : 'Sveže sestavine in pametni telefon v sodobni kuhinji'}
                className="w-full h-[460px] object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
              />
              
              {/* Floating badge */}
              <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-2 shadow-lg z-20 animate-pulse">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-ping"></div>
                  <span className="text-sm font-semibold text-gray-800">
                    {language === 'en' ? 'AI Recipes' : 'AI recepti'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
